import { RootState } from '@/store'
import { storeActions } from '@/store/actions'
import { ChatMessage } from '@/store/beneficiary'
import { Middleware, PayloadAction } from '@reduxjs/toolkit'
import {
  GenerateChatResponseParams,
  GenerateWelcomeMessageParams,
  GenerationEnum,
  GenerationEvent,
} from '@repo/shared/events/generation'
import { generateId } from '@repo/shared/uuid/uuid'
import { DataStatus } from '@repo/ui/utils'

export interface ISocket {
  emit: <T>(key: string, payload: T) => void
  listen: <T>(key: string, cb: (v: T) => void) => void
}

export const socketIOMiddleware =
  (UseSocket: ISocket): Middleware<object, RootState> =>
  // @ts-expect-error - Middleware type requires specific action type but we handle unknown actions
  (store) => {
    return (next) => (rawAction: PayloadAction<unknown>) => {
      const newAction = next(rawAction) // Required to be called at very first place
      const state = store.getState()

      const beneficiaryId =
        DataStatus.isFulfilled(state.beneficiary.beneficiary) &&
        state.beneficiary.beneficiary.id
      const organizationId =
        DataStatus.isFulfilled(state.beneficiary.organization) &&
        state.beneficiary.organization.id
      const chatSessionId = state.beneficiary.currentSessionId
      const messages =
        DataStatus.isFulfilled(state.beneficiary.messages) &&
        state.beneficiary.messages

      switch (rawAction.type) {
        case storeActions.initChatSession.fulfilled.type:
          {
            if (
              beneficiaryId &&
              messages &&
              messages.length === 0 &&
              organizationId &&
              chatSessionId
            ) {
              UseSocket.emit<GenerateWelcomeMessageParams>(
                GenerationEnum.GenerateWelcomeMessage,
                {
                  beneficiaryId,
                  chatSessionId,
                  generationId: generateId(),
                  organizationId,
                },
              )
            }

            UseSocket.listen<GenerationEvent<ChatMessage>>(
              GenerationEnum.GenerateChatResponse,
              (generationEvent) => {
                if (generationEvent.payload)
                  store.dispatch(
                    storeActions.streamMessage({
                      chatMessage: {
                        ...generationEvent.payload,
                        streaming: true,
                      },
                    }),
                  )
              },
            )
          }
          break

        case storeActions.sendBeneficiaryMessage.type:
          {
            const action = rawAction as { payload: { message: string } }
            if (
              beneficiaryId &&
              chatSessionId &&
              organizationId &&
              action.payload.message
            ) {
              UseSocket.emit<GenerateChatResponseParams>(
                GenerationEnum.GenerateChatResponse,
                {
                  beneficiaryId,
                  chatSessionId,
                  generationId: generateId(),
                  organizationId,
                  message: action.payload.message,
                },
              )
            }
          }
          break

        default:
          break
      }
      return newAction
    }
  }
